import React from 'react'
import AlertDismissible from '../AlertDismissible'
import { Alert } from 'react-bootstrap'

const StudentNews = ({info : { inscripcion }}) => {
  return <>
    { !inscripcion ? null 
      :inscripcion.documentacion == true && !inscripcion.tiene_documento_rechazado || inscripcion.documentacion == false && !inscripcion.tiene_documento_rechazado
        ? <AlertDismissible 
            type='success'
            title="Atención"
            dismiss={false}
            message="Tu documentación está lista para su revisión. 
            Si es aceptada se te enviará un correo electrónico con la confirmación y tus credenciales para imprimir tu horario. 
            En caso de que algún documento no haya sido aceptado de igual forma se te notificará."
          />
        : inscripcion.documentacion == false || inscripcion.documentacion == null && inscripcion.tiene_documento_rechazado
          ? <AlertDismissible
              type='danger'
              title="Atención"
              dismiss={false}
              message="Alguno de tus documentos ha sido rechazado. Favor de tomar en consideración las observaciones realizadas para volver a subir el documento." 
            />
          : inscripcion.documentacion == null 
            && <AlertDismissible 
                type='info'
                title="Atención"
                dismiss={false}
                message="Es necesario subir la siguiente documentación para completar tu proceso de inscripción."
              />
    }
    {
      <Alert variant='info'>
        <h5>¿TIENES PROBLEMAS PARA VER LOS CAMBIOS REFLEJADOS?</h5>
        <p><strong>EN CASO DE QUE NO VEAS LOS CAMBIOS REFLEJADOS AL VOLVER SUBIR UN DOCUMENTO, LIMPIA LA CACHE DE TU NAVEGADOR O PULSA <kbd>CTRL</kbd> + <kbd>F5</kbd> PARA ACTUALIZAR LA PÁGINA.</strong></p>
      </Alert>
    }
  </>
}


export default StudentNews